module.exports = __webpack_public_path__ + "static/media/md.bac706e4.svg";